module.exports = __webpack_public_path__ + "img/map_Z5.3.A.03.98eac461.svg";